<template>
  <div>
    <b-row class="pt-2 pb-1">
      <b-col cols="12" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
    </b-row>

    <b-card-group deck class="mx-2">
      <b-card class="m-0" no-body>
        <div class="m-2">
          <b-row>
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label class="text-capitalize">{{ $t("table.entries") }}</label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search') + '...'"
                />
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          ref="refListTable"
          class="position-relative"
          :items="fetchList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          :empty-text="$t('no_record_found')"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #head()="data">
            <span>{{ $tc(data.label, 1) }}</span>
          </template>

          <template #cell(user)="data">
            {{ data.item.user ? data.item.user.name : "-" }}
          </template>

          <template #cell(device)="data">
            {{ data.item.device ? data.item.device.name || data.item.device.serial_number : "-" }}
          </template>

          <template #cell(status)="data">
            <b-badge :variant="data.item.status === 'Complete' ? 'light-success' : 'light-warning'">
              {{ data.item.status }}
            </b-badge>
          </template>

          <template #cell(files)="data">
            <div v-if="data.item.files && data.item.files.length">
              <div class="mb-50">
                <b-button
                  v-if="hasVideo(data.item)"
                  size="sm"
                  variant="primary"
                  class="mr-50"
                  :disabled="busy[data.item.id]"
                  @click="playRecording(data.item)"
                >
                  <feather-icon icon="PlayIcon" size="14" class="mr-25" />
                  {{ $t("axis_body_cam.recordings.play") }}
                </b-button>
                <b-button
                  v-if="data.item.files.length > 1"
                  size="sm"
                  variant="outline-primary"
                  :disabled="busy[data.item.id]"
                  @click="downloadAll(data.item)"
                >
                  <feather-icon icon="DownloadCloudIcon" size="14" class="mr-25" />
                  {{ $t("axis_body_cam.recordings.download_all") }}
                </b-button>
              </div>
              <b-button
                v-for="file in data.item.files"
                :key="file.id"
                size="sm"
                variant="flat-secondary"
                class="mr-50 mb-50"
                :disabled="busy[data.item.id]"
                @click="downloadFile(data.item, file)"
              >
                <feather-icon icon="DownloadIcon" size="14" class="mr-25" />
                {{ file.object_name }}
              </b-button>
            </div>
            <span v-else class="text-muted">{{ $t("axis_body_cam.recordings.no_files") }}</span>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted text-capitalize">{{
                $t("table.showing", { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of })
              }}</span>
            </b-col>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <Pagination :totalList="totalList" :currentPage="currentPage" @updatePagination="update" :perPage="perPage" />
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-card-group>

    <RecordingPlayer ref="refPlayer" />
  </div>
</template>

<script>
import { BRow, BCol, BCard, BFormInput, BTable, BBadge, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import useList from "./useList";
import Pagination from "@/components/Pagination.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import RecordingPlayer from "./RecordingPlayer.vue";

export default {
  components: {
    BreadcrumbMenu,
    RecordingPlayer,
    Pagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BButton,
    vSelect,
  },
  setup() {
    return {
      ...useList(),
    };
  },
};
</script>
